<template>
    <div>
        <div class="panel">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-info"></i>
                    <span>{{$t('dashboard.trajectory_info.title')}}</span>
                </h2>
                <div @click.prevent="editTrajectory" class="panel_header__action">
                    <i class="panel_header__action__icon icons icon-pencil"></i>
                    <a class="button--link">{{$t('common.edit')}}</a>
                </div>
            </div>
            <div class="panel__body">
                <div v-if="loading">
                    <div class="spinner"></div>
                </div>
                <transition name="fade" mode="out-in">
                    <div v-if="!loading">
                        <div>
                            <strong>
                                {{$t('dashboard.trajectory_info.status')}}

                            </strong>
                            <br/>
                            {{trajectory.trajectory_state.name | capitalize}}
                            <br/>
                            <a v-if="!showHistory && trajectory.history.length" @click="showHistory = true">
                                {{$t('dashboard.trajectory_info.show_history')}}
                            </a>
                            <a v-if="showHistory" @click="showHistory = false">{{$t('dashboard.trajectory_info.hide_history')}}</a>
                        </div>

                        <transition name="fade" mode="in-out">
                            <div v-if="showHistory">
                                <div v-for="change in trajectory.history" :key="change.id">
                                    {{change.date | formatDate}} - {{change.state.name}}
                                </div>
                                <br/>
                            </div>
                        </transition>

                        <p v-if="trajectory.reject_reason">
                            <strong>{{$t('dashboard.trajectory_info.reject_reason')}}</strong>
                            <br/>
                            {{trajectory.reject_reason | capitalize}}
                        </p>

                        <p v-if="isInCompletedState && trajectory.completed_reason">
                            <strong>{{$t('dashboard.trajectory_info.completed_reason')}}</strong>
                            <br/>
                            {{trajectory.completed_reason | capitalize}}
                        </p>

                        <p>
                            <strong>{{$t('dashboard.trajectory_info.registration_date')}}</strong>
                            <br/>
                            {{trajectory.registration_date | formatDate}}
                        </p>

                        <p>
                            <strong>{{$t('dashboard.trajectory_info.intake_date')}}</strong>
                            <br/>
                            {{trajectory.intake_date | formatDate}}
                        </p>

                        <button v-if="trajectory.trajectory_state.code === 'new'" @click="showStartClientModal" class="button--cta">{{$t('dashboard.trajectory_info.start_client_trajectory')}}</button>
                        <button v-else-if="trajectory.trajectory_state.code === 'proposal_needed'" @click="showStartEmployerModal" class="button--cta">{{$t('dashboard.trajectory_info.start_employer_trajectory')}}</button>
                        <button v-else-if="trajectory.trajectory_state.code === 'in_progress'" @click="showCompleteTrajectory" class="button--cta">{{$t('dashboard.trajectory_info.complete_trajectory')}}</button>
                    </div>
                </transition>
            </div>
        </div>
        <trajectory-edit-modal />
        <trajectory-start-client-modal />
        <trajectory-start-employer-modal />
        <trajectory-complete-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    import Trajectory from '@/models/Trajectory';
    import ClientForm from '@/components/forms/dashboard/ClientForm';
    import TrajectoryEditModal from '@/components/modals/dashboard/TrajectoryEditModal';
    import TrajectoryStartClientModal from '@/components/modals/dashboard/TrajectoryStartClientModal';
    import TrajectoryStartEmployerModal from '@/components/modals/dashboard/TrajectoryStartEmployerModal';
    import TrajectoryCompleteModal from '@/components/modals/dashboard/TrajectoryCompleteModal';

    import { GET_TRAJECTORY } from '@/store/modules/trajectory';
    import { FINISHED_STATES_CODES } from '@/store/modules/trajectory-resources';

    @Component({
        components: {
            TrajectoryEditModal,
            TrajectoryStartClientModal,
            TrajectoryStartEmployerModal,
            TrajectoryCompleteModal,
        }
    })
    export default class TrajectoryInfoPanel extends Vue {
        name = 'trajectory-info-panel';

        showHistory = false;

        get loading() {
            return this.$store.state.trajectory.loading;
        }

        get trajectory() {
            return this.$store.state.trajectory.trajectory;
        }


        get isInCompletedState() {
            return FINISHED_STATES_CODES.includes(this.trajectory.trajectory_state.code);
        }

        editTrajectory() {
            this.$modal.show('trajectory-edit-modal', { trajectory: this.trajectory});
        }

        showStartClientModal() {
            this.$modal.show('trajectory-start-client-modal');
        }

        showStartEmployerModal() {
            this.$modal.show('trajectory-start-employer-modal');
        }

        showCompleteTrajectory() {
            this.$modal.show('trajectory-complete-modal');
        }

        toggleHistory() {
            this.showHistory = !this.showHistory;
        }

    }

</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/TrajectoryInfoPanel.vue